import { render, staticRenderFns } from "./flow6.vue?vue&type=template&id=01da6ab0&scoped=true&"
import script from "./flow6.vue?vue&type=script&lang=js&"
export * from "./flow6.vue?vue&type=script&lang=js&"
import style0 from "./flow6.vue?vue&type=style&index=0&id=01da6ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da6ab0",
  null
  
)

export default component.exports